/**
 * Deploy-window guard (YAR-477 / YAR-485).
 *
 * Railway can serve a new web bundle before `supabase-deploy-*` has applied
 * that release's migrations — on the main push to staging and again on the
 * promotion to production. For that window the bundle talks to the OLD
 * schema, and asking PostgREST for something the schema does not have yet
 * fails the WHOLE request (the Review tab went dark this way on 2026-09-10).
 *
 * Callers that read a new column or call a new RPC check this and retry the
 * way the previous release did. Once the migrations are everywhere the
 * fallback branches are dead code and can be deleted.
 *
 *   PGRST204  column missing from PostgREST's schema cache (insert/update)
 *   42703     undefined_column (select of a column that does not exist)
 *   42501     permission denied — a column that exists but whose
 *             column-level SELECT grant has not been applied yet
 *   PGRST202  function missing from the schema cache (RPC)
 *   42883     undefined_function
 */
export function isSchemaNotReadyError(err: unknown): boolean {
  const code = (err as { code?: unknown } | null)?.code;
  return (
    code === 'PGRST204' ||
    code === '42703' ||
    code === '42501' ||
    code === 'PGRST202' ||
    code === '42883'
  );
}

/** A missing RPC specifically (a 42501 from inside an RPC is a real denial). */
export function isMissingFunctionError(err: unknown): boolean {
  const code = (err as { code?: unknown } | null)?.code;
  return code === 'PGRST202' || code === '42883';
}
